import { render, staticRenderFns } from "./QuoteProductPiecesList.vue?vue&type=template&id=2bab06d4&"
import script from "./QuoteProductPiecesList.vue?vue&type=script&lang=js&"
export * from "./QuoteProductPiecesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports